import * as React from 'react';
import { Input as InputPrimitive } from '@base-ui/react/input';
import { FieldError as HookFormFieldError } from 'react-hook-form';

import { cn } from 'utils/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  isTouched?: boolean;
  error?: HookFormFieldError;
}

function Input({ className, type, label, error, isTouched, ...props }: InputProps) {
  return (
    <div className='flex flex-col gap-[6px]'>
      {label && <label className='text-xs font-[MuseoSansCyrl]'>{label}</label>}

      <InputPrimitive
        type={type}
        data-slot='input'
        aria-invalid={!!error}
        className={cn(
          'w-full rounded-[8px] border bg-transparent px-[10px] py-[8px] font-[MuseoSansCyrl] text-[14px] outline-none transition-colors placeholder:text-lightgrey500',
          error ? 'border-red' : 'border-content-secondary',
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        {...props}
      />

      {isTouched && error && <div className='text-red text-[14px] font-[MuseoSansCyrl]'>{error.message}</div>}
    </div>
  );
}

export { Input };
